import { useContext } from 'react';
import { css } from 'styled-components';

import { rem } from 'approot/shared/style';
import { ActivityBuilderThemeContext } from './activity-builder-theme';

function getSize(size: number, isZoomed?: boolean) {
  return isZoomed ? size * 1.5 : size;
}

export const useActivityBuilderFontStyles = (options?: {
  isZoomed?: boolean;
  isSmall?: boolean;
}) => {
  const { theme } = useContext(ActivityBuilderThemeContext);

  return css`
    font-size: ${rem(
      getSize(
        options?.isSmall
          ? theme.theming.font.small.size
          : theme.theming.font.medium.size,
        options?.isZoomed
      )
    )};
    line-height: ${rem(
      getSize(
        options?.isSmall
          ? theme.theming.font.small.lineHeight
          : theme.theming.font.medium.lineHeight,
        options?.isZoomed
      )
    )};
    min-height: ${rem(
      getSize(
        options?.isSmall
          ? theme.theming.font.small.lineHeight
          : theme.theming.font.medium.lineHeight,
        options?.isZoomed
      )
    )};
  `;
};

export const useActivityBuilderFontSize = (options?: {
  isZoomed?: boolean;
  isSmall?: boolean;
}) => {
  const { theme } = useContext(ActivityBuilderThemeContext);

  return css`
    font-size: ${rem(
      getSize(
        options?.isSmall
          ? theme.theming.font.small.size
          : theme.theming.font.medium.size,
        options?.isZoomed
      )
    )};
  `;
};
